<template>
  <div class="remind-record">
     <el-dialog :visible.sync="show" custom-class="detail_dialog" width="1200px" :fullscreen="isExpand"
      :show-close="false" :before-close="handleClose" :destroy-on-close="true">
      <template slot="title">
        <div class="default-dialog-title-box">
          <span>提醒记录</span>
          <span class="icon-box">
            <img :src="!isExpand ? expandSvg : collapseSvg" @click="isExpand = !isExpand">
            <i class="el-icon-close" @click="handleClose"></i>
          </span>
        </div>
      </template>
      <a-table ref="logTableRef" :scroll="{ x: '100%', y: 540 }" :components="components" :data-source="tableData" :columns="columns" :pagination="false" :rowKey="'id'">
      </a-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" plain @click="handleClose">关闭</el-button>
      </span>
     </el-dialog>
  </div>
</template>
<script>
import * as Moment from 'dayjs';
import DraggableResizeMixin from '@/mixins/draggableResizeMixin.js';
import { queryPage } from '@/api/messages';

export default {
  props: {
    linkId: {
      type: String,
      default: '',
    },
    objId: {
      type: String,
      default: '',
    },
    remindType: {
      type: [String, Number],
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [DraggableResizeMixin],
  watch: {
    show (v) {
      if (v) {
        this.queryList();
      }
    },
  },
  computed: {
    columns () {
      return [
        {
          title: '发起人',
          dataIndex: 'createUserName',
          key: 'createUserName',
          width: 120,
          ellipsis: true,
        },
        {
          title: '接收人',
          dataIndex: 'remindUserName',
          key: 'remindUserName',
          width: 120,
          ellipsis: true,
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          width: 180,
          ellipsis: true,
          customRender: (text) => {
            return text ? Moment(text * 1).format('YYYY-MM-DD HH:mm:ss') : '/';
          },
        },
        {
          title: '提醒时间',
          dataIndex: 'remindTime',
          key: 'remindTime',
          width: 180,
          ellipsis: true,
          customRender: (text) => {
            return text ? Moment(text * 1).format('YYYY-MM-DD HH:mm:ss') : '/';
          },
        },
        {
          title: '提醒内容',
          dataIndex: 'content',
          key: 'content',
          ellipsis: true,
        },
      ];
    },
  },
  data () {
    return {
      isExpand: false,
      expandSvg: require('@/assets/ic_expand.svg'),
      collapseSvg: require('@/assets/ic_collapse.svg'),
      tableData: [],
      pageNum: 1,
      pageSize: 99999,
    };
  },
  methods: {
    handleClose () {
      this.$emit('close', false);
    },
    async queryList () {
      const data = await queryPage({
        linkId: this.linkId,
        objId: this.objId,
        remindType: this.remindType,
        onTimeRemindFlag: false,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        findSelfCreateFlag: true,
      });
      this.tableData = data.body.list || [];
    },
  },
};
</script>
<style lang="scss" scoped>
.remind-record {
  .detail_dialog {
    /deep/ .el-dialog__header {
      padding: 16px 20px;
    }
  }
}
</style>
